// Admin centre API — endpoints injected into the single baseApi (ARCHITECTURE §7).
import { baseApi } from '@/lib/api/baseApi';
import { adminEndpoints } from './admin.queries';

export const adminApi = baseApi.injectEndpoints({ endpoints: adminEndpoints });

export const {
  useGetAccessUsersQuery,
  useInviteUserMutation,
  useUpdateUserMutation,
  useSendInvitationReminderMutation,
  useRemoveUserMutation,
  useRevokeInvitationMutation,
  useGetActivityLogsQuery,
} = adminApi;
